import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "../Reveal";
import { MODULES, TREE_IMAGE } from "../../data/modules";
import { useI18n } from "../../i18n/I18nContext";

const SPANS = {
  0: "md:col-span-3",
  1: "md:col-span-3",
  2: "md:col-span-2",
  3: "md:col-span-2",
  4: "md:col-span-2",
  5: "md:col-span-3",
  6: "md:col-span-3",
  7: "md:col-span-6",
};

const ModuleCard = ({ m, delay }) => {
  const { t, moduleText } = useI18n();
  const dark = m.id === 6;
  const isTrueLife = m.id === 7;
  return (
    <Reveal delay={delay} className={SPANS[m.id]}>
      <Link
        to="/simulateur"
        data-testid={`module-card-${m.id}`}
        className={`group relative flex flex-col justify-between h-full min-h-[240px] rounded-3xl p-8 md:p-10 overflow-hidden transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_-24px_rgba(26,29,26,0.25)] ${
          dark ? "bg-ink text-paper" : "bg-white text-ink"
        }`}
      >
        {isTrueLife && (
          <>
            <img src={TREE_IMAGE} alt="" className="absolute inset-0 w-full h-full object-cover opacity-90" />
            <div className="absolute inset-0 bg-white/55" />
          </>
        )}
        <div className="relative flex items-start justify-between">
          <span className={`font-serif text-sm tracking-[0.3em] ${dark ? "text-paper/50" : "text-smoke/70"}`}>
            {String(m.id).padStart(2, "0")}
          </span>
          <span className={`text-sm font-medium ${dark ? "text-sage" : "text-sagedark"}`}>
            {m.priceLabel}{m.price > 0 && <span className="text-xs opacity-70"> {t("modules.perMonth")}</span>}
          </span>
        </div>
        <div className="relative mt-10">
          <h3 className="font-serif text-3xl md:text-4xl tracking-tight">{m.name}</h3>
          <p className={`mt-2 text-xs uppercase tracking-[0.18em] ${dark ? "text-paper/50" : "text-smoke/80"}`}>{moduleText(m.id, "range", m.range)}</p>
          <p className={`mt-4 text-sm leading-relaxed max-w-md ${dark ? "text-paper/70" : "text-smoke"}`}>{moduleText(m.id, "tagline", m.tagline)}</p>
          <span className={`mt-6 inline-flex items-center gap-2 text-sm ${dark ? "text-paper" : "text-ink"}`}>
            {t("modules.oriented")}
            <ArrowUpRight size={16} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </span>
        </div>
      </Link>
    </Reveal>
  );
};

export const Modules = () => {
  const { t } = useI18n();
  return (
  <section id="modules" data-testid="modules-section" className="py-28 md:py-40 bg-bone">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div>
          <Overline>{t("modules.overline")}</Overline>
          <h2 className="mt-6 font-serif text-4xl md:text-6xl tracking-tight text-ink max-w-2xl leading-tight">
            {t("modules.title")}
          </h2>
        </div>
        <p className="max-w-sm text-sm md:text-base leading-relaxed text-smoke">
          {t("modules.sub")}
        </p>
      </Reveal>

      <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-6 gap-6 md:gap-8">
        {MODULES.map((m, i) => (
          <ModuleCard key={m.id} m={m} delay={0.05 * (i % 3)} />
        ))}
      </div>
    </div>
  </section>
  );
};
